import React, { useState, useContext, useEffect, useRef } from 'react';
import { Link, Navigate, Route, useNavigate } from 'react-router-dom';

// Custom scrollbar
import { Scrollbars, positionValues } from 'react-custom-scrollbars-2';
import Collapsible from 'react-collapsible';
// Cookies
import { useCookies } from 'react-cookie';

// Redyx
import { useDispatch } from 'react-redux';
import { globalSlice } from '../../services/globalSlice/globalSlice';

// API
import API from '../../services/api/api';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';

import IconButton from '@mui/material/IconButton';
import SettingContext, { iView } from '../../services/context/setting-contentxt/setting-context';
import Drawer from '@mui/material/Drawer';

import {DropDownMenu} from './dropdown_menu'
import MenuIcon from '@mui/icons-material/Menu';
// Stylesheet
import './Nav.css';

// Components
import {
  LanguageSwitcher,
  LightDarkModeSwitcher,
} from '../FormElements/FormElements';

// Assets
import Logo from '../../assets/images/logo/primary.svg';
import LogoTab from '../../assets/images/logo/logo_tab.png'

import EditProfile from '../../containers/EditProfile/EditProfile';
import { editProfileSlice } from '../../containers/EditProfile/EditProfileSlice';
import { getLanguage, useTranslation } from 'react-multi-lang';
import { Avatar, List, ListItem, ListItemButton, ListItemIcon, ListItemText } from '@mui/material';
import { useAPI } from '../../services/hoc/useAPI';


interface NavProps {

    icon:  string | React.ReactElement;
    name: string;
    link?: string;
    show: boolean;
    childs?: {
      icon: string | React.ReactElement;
      name: string;
      link: string;
      show: boolean;
    }[];
  

}

export const SideNav_v1 = (props:any)=>{
  const [activeBox,setActiveBox]=useState(0)

const myRef = useRef<null | Scrollbars>(null)

  const  getActiveBoxPositionByIndex = (index: number): number => {

    return index * 90;
  };


 const handleCollaps=(index:number)=>{
    
  if (activeBox ===getActiveBoxPositionByIndex(index )) {
   
    setActiveBox((pre)=>-1)
  }
  else {
 
setActiveBox((state)=>getActiveBoxPositionByIndex(index ))
  //setActiveBox(getActiveBoxPositionByIndex(index ))
  }
  }
  
 const handleUpdate=(values:positionValues)=>{

  if(activeBox===360)(myRef.current as Scrollbars).scrollToBottom();

}

  return (
      <nav className="side-nav" >
        <Scrollbars
      
        id="side-nav"
          autoHeight
          autoHeightMin="75vh"
          autoHide 
          ref={myRef}
          onUpdate={handleUpdate}
          
          renderTrackHorizontal={(props) => (
            <div
              {...props}
              className="track-horizontal"
              style={{ display: 'none' }}
            />
          )}
          renderThumbHorizontal={(props) => (
            <div
              {...props}
              className="thumb-horizontal"
              style={{ display: 'none' }}
            />
          )}>
          <div className="active-box" style={{ top: activeBox }} 
          
          
          />
          <ul>
            {props.list.map((item:any, index:number) => {
         
              if (!item.show) return;
              if (item.childs)
                return (
                  <React.Fragment key={'side-' + index}>
                    <li
                      key={'side-' + index}
                      className={
                        item.childs
                          .map((item:any) => item.link.substring(1))
                          .includes(props.active || '')
                          ? 'active'
                          : ''
                      }
                      onClick={() =>
                        handleCollaps(index)
                      }>
                      <Link to={item.childs[0]?.link || ''}>
                        <span style={{display:'flex',flexDirection:'column',alignItems:'center'}}>
                          
                          {
                            typeof(item.icon) ==='string'?
                            <i className={item.icon}></i> :
                            item.icon
                            }{item.name}
                        </span>
                      </Link>
                    </li>
                  

                    <Collapsible
                      key={'collapse-' + index}
                      open ={
                        
                        activeBox !==-1 &&
                         item.childs
                         .map((item:any) => item.link.substring(1))
                         .includes(props.active || '')
                       
                      }
                      trigger={ ''
                        }>
                      <ul>
                        {item.childs.map((child:any, child_index:number) => (
                          <li
                            key={'child-' + index + '-' + child_index}
                            
                            className={
                              child.link.substring(1) === props.active
                                ? 'active'
                                : ''
                            }>
                            <Link to={child.link} onClick={()=>{
                              if (props.closeNavebar){
                                props.closeNavebar()
                              
                            }}}>
                              <span>
                              { typeof(child.icon)==='string'?
                              <i className={child.icon}></i>:child.icon
                                }{child.name}
                              </span>
                            </Link>
                          </li>
                        ))}
                      </ul>
                    </Collapsible>
                   
                  </React.Fragment>
                );
              else
                return (
                  <li
                    key={'side-2' + index}
                    className={
                      item.link?.substring(1) === props.active ? 'active' : ''
                    }
                    onClick={() =>
                      setActiveBox(()=>getActiveBoxPositionByIndex(index))
                    }>
                    <Link to={item.link || ''}>
                      <span style={{display:'flex',flexDirection:'column'}}>
                      {
                            typeof(item.icon) ==='string'?
                            <i className={item.icon}></i> :
                            item.icon
                            } <span>

                            {item.name}
                            </span>
                      </span>
                    </Link>
                  </li>
                );
            })}
          </ul>
        </Scrollbars>
      </nav>
  
  );
  
}

export class SideNav extends React.Component<any,any> {
  myRef: React.RefObject<unknown>;
  static contextType = SettingContext
  constructor(props:any){
    super(props)
    this.myRef=React.createRef()
    
    this.state={
      activeBox:this.getActiveBoxPositionByIndex(this.getActiveIndexByName(props.active))
    }
    this.getActiveIndexByName=this.getActiveIndexByName.bind(this)
    this.getActiveBoxPositionByIndex=this.getActiveBoxPositionByIndex.bind(this)
    this.handleCollaps=this.handleCollaps.bind(this)
    this.handleUpdate=this.handleUpdate.bind(this)
  }
  
   getActiveIndexByName = (name: string | null): number => {
    let matched_index = -1;
    this.props.list?.map((item:any, index:number) => {
        item.childs?.map((sub_item:any)=>{
            if (sub_item.link?.substring(1)=== name) matched_index=index
        })
      //if (item.link?.substring(1) === name) matched_index = index;
    });
    return matched_index;
  };

   getActiveBoxPositionByIndex = (index: number): number => {

    return index * 90;
  };


   handleCollaps=(index:number)=>{
    
  if (this.state.activeBox ===this.getActiveBoxPositionByIndex(index )) {
   
    this.setState((pre:any)=>({activeBox:-1}))
  }
  else {
 
this.setState((state:any)=>({activeBox:this.getActiveBoxPositionByIndex(index )}))
  //setActiveBox(getActiveBoxPositionByIndex(index ))
  }
  }

 handleUpdate=(values:positionValues)=>{

  if(this.state.activeBox===360)(this.myRef.current as Scrollbars).scrollToBottom();

}

  
render(){


const {isPc}= this.context as iView



  return (


      <nav className="side-nav" >
        <Scrollbars
      
        id="side-nav"
          autoHeight
          autoHeightMin="75vh"
          autoHide 
          ref={this.myRef as any}
          onUpdate={this.handleUpdate}
          
          renderTrackHorizontal={(props) => (
            <div
              {...props}
              className="track-horizontal"
              style={{ display: 'none' }}
            />
          )}
          renderThumbHorizontal={(props) => (
            <div
              {...props}
              className="thumb-horizontal"
              style={{ display: 'none' }}
            />
          )}>
          <div className="active-box" style={{ top: this.state.activeBox }} 
          
          
          />
          <ul>
            {this.props.list.map((item:any, index:number) => {
         
              if (!item.show) return;
              if (item.childs)
                return (
                  <React.Fragment key={'side-' + index}>
                    <li
                      key={'side-' + index}
                      className={
                        item.childs
                          .map((item:any) => item.link.substring(1))
                          .includes(this.props.active || '')
                          ? 'active'
                          : ''
                      }
                      onClick={() =>
                        this.handleCollaps(index)
                      }>
                      <Link to={item.childs[0]?.link || ''}>
                        <span style={{display:'flex',flexDirection:'column',alignItems:'center'}}>
                          
                          {
                            typeof(item.icon) ==='string'?
                            <i className={item.icon}></i> :
                            item.icon
                            }{item.name}
                        </span>
                      </Link>
                    </li>
                  

                    <Collapsible
                      key={'collapse-' + index}
                      open ={
                        
                        this.state.activeBox !==-1 &&
                         item.childs
                         .map((item:any) => item.link.substring(1))
                         .includes(this.props.active || '')
                       
                      }
                      trigger={ ''
                        }>
                      <ul>
                        {item.childs.map((child:any, child_index:number) => (
                          <li
                            key={'child-' + index + '-' + child_index}
                            
                            className={
                              child.link.substring(1) === this.props.active
                                ? 'active'
                                : ''
                            }>
                            <Link to={child.link} onClick={()=>{
                              if (this.props.closeNavebar){
                                this.props.closeNavebar()
                              
                            }}}>
                              <span>
                              { typeof(child.icon)==='string'?
                              <i className={child.icon}></i>:child.icon
                                }{child.name}
                              </span>
                            </Link>
                          </li>
                        ))}
                      </ul>
                    </Collapsible>
                   
                  </React.Fragment>
                );
              else
                return (
                  <li
                    key={'side-2' + index}
                    className={
                      item.link?.substring(1) === this.props.active ? 'active' : ''
                    }
                    onClick={() =>
                      this.setState(()=>({activeBox:this.getActiveBoxPositionByIndex(index)}))
                    }>
                    <Link to={item.link || ''}>
                      <span style={{display:'flex',flexDirection:'column'}}>
                      {
                            typeof(item.icon) ==='string'?
                            <i className={item.icon}></i> :
                            item.icon
                            } <span>

                            {item.name}
                            </span>
                      </span>
                    </Link>
                  </li>
                );
            })}
          </ul>
        </Scrollbars>
      </nav>
  
  );
};
}


interface SideNavItemProps {key:any,icon:string | React.ReactElement,name:string
  ,link:string ,onClick:Function ,active:boolean}
const SideNavItem = (props:SideNavItemProps)=>
<ListItem key={props.key} disablePadding
sx={{
  background:props.active?'#367d61':'transparent',
  borderRadius:'25px',

  
}}>
<ListItemButton>
  <Link to={props.link} 
   
  style={{
    display:'flex',
    textDecoration:'none',
    color:'white',
    alignItems:'center',
    
}}
  
  onClick={()=>props.onClick()}
  >
    <ListItemIcon>
    <i style={{color:'white'}} className={props.icon as string}></i>
  
    </ListItemIcon>
    <ListItemText primary={props.name} >
      
      </ListItemText>
  </Link>
</ListItemButton>
</ListItem>


export const TopNav = (props:{children?:React.ReactElement | null,navList?:NavProps[]}) => {
  const menuRef=React.useRef<any>(null)
  const { isPc } = useContext(SettingContext);
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  // React hooks
  const [redirect, setRedirect] = useState<boolean>(false);
  const [openNavbar, setOpenNavpar] = useState({open:false,active_link:'/'});

  // Cookies hooks
  const [cookie, __, removeCookie] = useCookies();

  // Redux
  const dispatch = useDispatch();
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const closeOpenMenus = (e:MouseEvent)=>{

   
    if(menuRef.current && Boolean(anchorEl)){
      setAnchorEl(null)
    }
}

  // Translation
  const t = useTranslation();
  const navigate=useNavigate()

  // API
 const ENDPOINTS = useAPI()
  const logout = () => {
   
    dispatch(globalSlice.actions.setIsLoading(true));
    
    ENDPOINTS.auth()
      .logout(null)
      .then((response: any) => {
        if (response.data.message === 'Success! :D') {
       
          removeCookie('userinfo');
          dispatch(globalSlice.actions.setIsLoading(false));
          navigate("/login")
          setTimeout(() => {
            setRedirect(true);
            window.location.reload();
          }, 10);
         
        }
      });
  };
  useEffect(()=>{
    document.addEventListener('click',closeOpenMenus)
    return (()=>document.removeEventListener('click',closeOpenMenus))
  },[])

  if (isPc) {
    return (
      <nav className="top-nav">
        <img src={Logo} className="logo" style={{cursor:'pointer'}}
        onClick={()=>navigate('/')} />

         <div className="actions">
         

            <div className="switchers">
              <LightDarkModeSwitcher />
              <span className="margin-10" />
              <LanguageSwitcher />
            </div>
       
          <div
            className="userinfo"
            onClick={(e:React.MouseEvent) => {
              handleClick(e as any)
            
              }}>
            <span>
              <strong>{cookie?.userinfo?.name}</strong> <br />{' '}
              {cookie?.userinfo?.role?.name}
            </span>
            <i className="icon-username-1" />
          </div>
          <div  ref={menuRef as any} >

          <DropDownMenu 
          ref={menuRef}
          setAnchorEl={setAnchorEl}
          handleClick={handleClick}
          anchorEl={anchorEl}
          data={[
            {name:t('edit_profile'),link:'',icon:  <i className="icon-username-1" />,onClick:()=>  
              dispatch(editProfileSlice.actions.setIsOpen(true))},
            {name:t("logout"),link:'',icon:<i className="icon-logout"  />,onClick:()=>logout()}
            ,
            

          ]}
          />
          </div>

       
        </div> 

        {redirect ? (
          <Route path="*" element={<Navigate to="/" replace />} />
        ) : (
          ''
        )}

        <EditProfile />
      </nav>
    );
  }
  return (
    <>
      <Box sx={{ flexGrow: 1 }}>
        <AppBar position="static" sx={{background:'var(--primary-color)'}}>
          <Toolbar sx={{
            justifyContent:'end'
          }}>
            
            <Box sx={{flexGrow:1 ,display:'flex' }}>

            <IconButton
              size="large"
              edge="start"
              color="inherit"
              aria-label="menu"
              sx={{ mr: 2 }}
              onClick={() => setOpenNavpar((pre)=>({...pre,open:true}))}
              >
              <MenuIcon  />
            </IconButton>
            <div className='logo-container'>

              <img src={LogoTab} className="logo" style={{cursor:'pointer'}}
          onClick={()=>navigate('/')} />
            </div>
            </Box>
            <Box sx={{display:'flex',alignItems:'center'}}>
              <div className="top-nav" style={{boxShadow:'none'}}>

                <div className='actions'>

                  <div className="switchers">
                  <LightDarkModeSwitcher />
                  <span className="margin-10" />
                  <LanguageSwitcher />
                  </div>
                </div>
              </div>
              <div style={{
                display:'flex',
                flexDirection:'column',
                alignItems:'end',
                marginInline:'6px',
                paddingBlock:'10px'
              }}>
                <strong>{cookie?.userinfo?.name}</strong>
                <span>

                  {cookie?.userinfo?.role?.name}
                </span>
              </div>
              <Avatar >
                 <i className="icon-username-1" />
              </Avatar>
            </Box>
      

          </Toolbar>
        </AppBar>
      </Box>
      <React.Fragment key={'drawer'}>
        <Drawer
          anchor={getLanguage()==='en'?'right': 'left'}
          open={openNavbar.open}
          onClose={() => setOpenNavpar(pre=>({...pre,open:false}))}
          sx={{
            '& .MuiDrawer-paper':{

              boxShadow:'none',
              justifyContent:'center',
              background:'transparent',
              bottom:'0',
              height:'auto'
            }
          }}
          >
            <List sx={{
              background:'var(--primary-color)',
              borderTopLeftRadius:'30px',
              borderTopRightRadius:'30px',
              maxHeight:'100vh',
              overflowY:'scroll',
              scrollbarWidth:'none'
             
            }}>
              {
                props.navList?.map((item,index)=>{
                     if (item.childs) {
                      return (
                        
                           <ListItem key={index}  
                           sx={{
                            display:'flex',
                            flexDirection:'column',
                            borderTop:index===0? 'none':'1px solid lightgray',
                            borderTopLeftRadius:'100px',
                            borderTopRightRadius:'100px',
                            alignItems:'flex-start'
                           }}>
                            <Box sx={{display:'flex',margin:'auto'}}>

                              <ListItemText primary={item.name} 
                            sx={{
                              '& .MuiTypography-root':{
                               color:'white',
                               fontSize:'1.2rem',
                               fontWeight:'bold'
                              }
                            }} />
                            </Box>
                               <List 
                              >
                                {
                                  item.childs.map((ele,key)=>
                                    <SideNavItem key={key} icon={ele.icon} name={ele.name} 
                                    link={ele.link} 
                                    active={ele.link === openNavbar.active_link}
                                    onClick={()=>setOpenNavpar(pre=>({...pre,open:false ,active_link:ele.link}))}
                                    />
                                    )
                                }
                               </List>
                        </ListItem>
                       
                      
                      )
                     }
                })
              }

            </List>
        </Drawer>
      </React.Fragment>
    </>
  );
};
